module.exports = __webpack_public_path__ + "img/logo.86567183.png";